import Form from '@utils/form'

export default new Form('purset.rate')
  .dataUrl('/srmTaxExchangeRate/getTaxExchangeRateById', process.env.VUE_APP_PURCHASE_API)
  .url('/srmTaxExchangeRate/updateTaxExchangeRate', process.env.VUE_APP_PURCHASE_API)
  .title('formTitle.baseInfo')
  .add('taxTypeNo').required().disabled()
  .add('taxTypeName').required()
  .add('taxRate').merge('number').required().attrs({ min: 0, max: 100 })
  .add('taxRateSign').required().component('el-checkbox').attrs({ trueLabel: 'Y', falseLabel: 'N' })
  .add('remarks').merge('textarea')
  .end()
